import axiosInstance from "@/store/api";
import DialerTreeConfig from "@/app/config";

export type VConResource =
  | { type: "call"; id: string }
  | { type: "contact"; id: string }
  | { type: "conversation"; id: string };

const pathFor = (resource: VConResource): string => {
  switch (resource.type) {
    case "call":
      return `/v1/calls/${resource.id}/vcon`;
    case "contact":
      return `/v1/contacts/${resource.id}/vcon`;
    case "conversation":
      return `/v1/conversations/${resource.id}/vcon`;
  }
};

export const vconFileName = (resource: VConResource): string => `vcon-${resource.type}-${resource.id}.json`;

export const fetchVCon = async (resource: VConResource): Promise<unknown> => {
  const response = await axiosInstance.get(`${DialerTreeConfig.baseAPIEndpoint}${pathFor(resource)}`);
  const payload = response.data as { data?: unknown } | null;
  return payload?.data ?? payload;
};

export const downloadJson = (fileName: string, data: unknown): void => {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};
